// extracted by mini-css-extract-plugin
module.exports = {"RedemptionSumsTable":"styles_RedemptionSumsTable__3n2Fr"};